import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Hero } from "@/components/landing/Hero";
import { Features } from "@/components/landing/Features";
import { Benefits } from "@/components/landing/Benefits";
import { PricingPlans } from "@/components/landing/PricingPlans";
import { CallToAction } from "@/components/landing/CallToAction";
import { Footer } from "@/components/landing/Footer";
import { Navigation } from "@/components/landing/Navigation";
import { PricingCalculator } from "@/components/landing/PricingCalculator";
import { OpportunityMessage } from "@/components/landing/OpportunityMessage";

const Index = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const initializeAuth = async () => {
      try {
        const { data: { session }, error } = await supabase.auth.getSession();
        
        console.log("Checking session on Index page:", { session, error });
        
        if (session) {
          console.log("User is authenticated, redirecting to opportunities");
          navigate("/opportunities");
        }
      } catch (error) {
        console.error("Error checking session:", error);
      }
    };

    initializeAuth();

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      console.log("Auth state changed on Index page:", event, session);
      
      if (event === 'SIGNED_IN' && session) {
        console.log("User signed in, redirecting to opportunities");
        navigate("/opportunities");
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [navigate]);

  return (
    <div className="flex min-h-screen flex-col">
      <Navigation />
      <main>
        <Hero />
        <Features />
        <Benefits />
        <PricingCalculator />
        <OpportunityMessage />
        <PricingPlans />
        <CallToAction />
      </main>
      <Footer />
    </div>
  );
};

export default Index;